module.exports = __webpack_public_path__ + "assets/img/news (41).33c5bec7.png";